module.exports = __webpack_public_path__ + "7a4fdc1d5e770f71f6cf305b76c4da5e.svg";